import { useMemo } from 'react';
import { canUpdate } from 'utils/permissions';
import { JobFamilyGroupModel } from '@utmost.co/enterprise-models';
import { PermissionActionsRetriever } from 'src/definitions/custom-models';

interface Args {
  loading: boolean;
  jobFamilyGroup?: JobFamilyGroupModel | null;
}

export const useDisabledJobFamilyGroupFields = (args: Args) => {
  const { loading, jobFamilyGroup } = args;

  return useMemo(() => {
    const shouldFieldsBeDisabled = (permissionRetriever: PermissionActionsRetriever): boolean =>
      loading || (Boolean(jobFamilyGroup) && !canUpdate(permissionRetriever(jobFamilyGroup?.permissions)));

    return shouldFieldsBeDisabled((permissions) => permissions?.JOB_FAMILY_GROUP);
  }, [loading, jobFamilyGroup]);
};
